import PeriprocedureelBeleidVKA from "../../../../src/client/lta-antistolling/periprocedureel-beleid-vka.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  PeriprocedureelBeleidVKA,
  ChartCollapse,
  React
};